/* @flow */
export const INITIAL_STATE: SettingsState = {
  startMorningsAtMinuteOffset: 360,
  laterTodayDelayMinutes: 180,
  startEveningsAtMinuteOffset: 1080,
  lastPostponedDate: null,
};

const listenForProps = Object.keys(INITIAL_STATE);

const mapDataToState = (state, data) => {
  const settingsUpdated = Object.keys(data)
    .filter((s) => listenForProps.includes(s))
    .reduce((acc, settingName) => {
      const settingValue = data[settingName];

      return { ...acc, [settingName]: settingValue };
    }, {});

  return { ...state, ...settingsUpdated };
};

const reducer = (state: SettingsState = INITIAL_STATE, action: LysterAction) => {
  if (action.type === 'SETTING_SYNCED') {
    const { payload: { data } } = action;

    return mapDataToState(state, data);
    // const { payload }
    // put value from server into store
  } if (action.type === 'SETTINGS_FETCHED') {
    const { payload } = action;
    // put value from server into store
    return mapDataToState(state, payload);
  } if (action.type === 'SETTINGS_RESET') {
    return { ...state, ...INITIAL_STATE };
  }
  return state;
};

export default reducer;
